import React from 'react';
import CallActions from 'actions/CallActions';
import CallStore from 'stores/files/CallStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import 'styles/ExpiredPage.styl';
import Button from '@material-ui/core/Button';
import {browserHistory} from 'react-router';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import {getQueryParam} from 'utils/getQueryParam';
import {CoachLogo} from '@components/logo/CoachLogo';

export const TYPE_INVALID_SHARE_TARGET = 'invalid_share_target';
export const TYPE_REDIRECTED_SHARE_TARGET = 'redirected_share';
export const TYPE_SMART_ALERT_CALL_NOT_ACCESSIBLE = 'smart_alert_call_not_accessible';
export const TYPE_COACHING_PLAN_COMPLETE = 'coaching_plan_complete';

@connectToStores
export default class ExpiredPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      waitingForQuery: false,
    };
  }

  static getStores() {
    return [CallStore];
  }

  static getPropsFromStores(props) {
    let teamName = null;
    const fileUploadId = getQueryParam(props.location, 'fileupload_id');
    if (fileUploadId) {
      teamName = CallStore.getState().teamNameByCall.get(fileUploadId);
    }
    return {
      teamName,
    };
  }

  componentDidMount() {
    const fileUploadId = getQueryParam(this.props.location, 'fileupload_id');
    if (this.getType() === TYPE_SMART_ALERT_CALL_NOT_ACCESSIBLE && fileUploadId) {
      this.setState({waitingForQuery: true});
      CallActions.fetchCallTeamName(fileUploadId).then(
        () => {
          this.setState({waitingForQuery: false});
        },
        () => {
          this.setState({waitingForQuery: false});
        }
      );
    }
    if (this.getType() === TYPE_COACHING_PLAN_COMPLETE) {
      // avoid dispatch in dispatch, which happens for reasons that will never be knowable by mortal men.
      CoachingPlaylistActions.reset.defer();
    }
  }

  /**
   * Return the type of the expired page.
   * Return null if this is the default expired page.
   */
  getType() {
    if (this.props.routeParams && this.props.routeParams['type']) {
      return this.props.routeParams['type'];
    } else {
      return null;
    }
  }

  /**
   * Get title text for the Expired page
   */
  getTitleText() {
    if (this.getType() === TYPE_SMART_ALERT_CALL_NOT_ACCESSIBLE) {
      return `Access Denied`;
    } else {
      return 'Expired';
    }
  }

  /**
   * Get main text for the Expired page
   */
  getMainText() {
    if (this.getType() === TYPE_INVALID_SHARE_TARGET) {
      return `You don't have permission to view the requested call.`;
    } else if (this.getType() === TYPE_REDIRECTED_SHARE_TARGET) {
      return '';
    } else if (this.getType() === TYPE_SMART_ALERT_CALL_NOT_ACCESSIBLE) {
      return `You don't have permission to view the requested call.`;
    } else if (this.getType() === TYPE_COACHING_PLAN_COMPLETE) {
      return `This coaching plan is complete.`;
    } else {
      return 'The link you clicked on is no longer active.';
    }
  }

  /**
   * Get bottom text for the Expired page
   */
  getBottomText() {
    if (this.getType() === TYPE_INVALID_SHARE_TARGET) {
      return `If somebody sent you this link, please email them and ask them to share the call
        by clicking on the "Share" button in the Coach interface.`;
    } else if (this.getType() === TYPE_REDIRECTED_SHARE_TARGET) {
      return `If you are clicking on a link that somebody sent you, it's
        possible that the share link was generated for somebody else.
        Please ask them to share the call with you again via the
        Coach platform.`;
    } else if (this.getType() === TYPE_SMART_ALERT_CALL_NOT_ACCESSIBLE) {
      const teamName = this.props.teamName;
      const message = teamName ? `on a team ${teamName} ` : ' ';
      return `A smart alert that was set up for you sent you an alert from a caller ${message}that your
        account administrator has not given you permission to access. Please ask one of the administrators on
        your account to grant you wider call permissions if necessary.`;
    } else if (this.getType() === TYPE_COACHING_PLAN_COMPLETE) {
      return '';
    } else {
      return 'If you are clicking on a link that somebody sent you, please ask them to send it again.';
    }
  }

  render() {
    const {waitingForQuery} = this.state;
    if (waitingForQuery) {
      return null;
    }
    return (
      <div className="expired-page">
        <nav className="navbar">
          <div className="left">
            <CoachLogo />
          </div>
          <div className="right">
            <div className="learn-more">
              <a href="https://support.mediafly.com/hc/en-us" target="_blank" rel="noreferrer">
                Learn More
              </a>
            </div>
          </div>
        </nav>
        <div className="main">
          <h2 className="title">{this.getTitleText()}</h2>
          <p className="text">{this.getMainText()}</p>
          <div className="expired-image" />
          <p className="text text-bottom">{this.getBottomText()}</p>
          {this.getType() === TYPE_COACHING_PLAN_COMPLETE && (
            <div>
              <Button
                variant="contained"
                color="primary"
                className="ev-button"
                onClick={goToDashboard}>
                Go to your dashboard
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ExpiredPage.displayName = 'ExpiredPage';

function goToDashboard() {
  browserHistory.push(`/`);
}
